import * as actionImport from './auth.actions';
import * as selectors from './auth.selectors';
import { reducerAuthActions } from './auth.reducer';

export { default } from './auth.reducer';

export const authActions = { ...actionImport, ...reducerAuthActions };
export const authSelectors = selectors;
